<template>
    <div class="noData">
        <svg t="1591667082671" 
            class="icon" 
            viewBox="0 0 1219 1024" 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            p-id="2873" 
            xmlns:xlink="http://www.w3.org/1999/xlink" width="238.0859375" height="200"
        >
            <path 
            d="M1160.899048 633.904762L915.748571 415.622095H278.918095L33.718857 
            633.904762 0 596.845714 259.559619 365.714286h675.547429L1194.666667 
            596.845714z" 
            p-id="2874"></path>
            <path d="M1142.905905 1024H76.190476C34.182095 1024
            0 990.232381 0 948.760381V585.142857h406.357333v25.063619c0 62.22019 
            51.273143 112.859429 114.273524 112.859429h177.785905c63.000381 0 
            114.273524-50.639238 114.273524-112.859429V585.142857H1219.047619
            v363.617524C1219.096381 990.232381 1184.914286 1024 1142.905905 
            1024zM50.809905 635.270095v313.490286c0 13.824 11.385905 25.063619 
            25.380571 25.063619h1066.715429c13.994667 0 25.35619-11.215238 
            25.35619-25.063619V635.270095H861.622857c-12.288 78.043429-80.749714 
            137.97181-163.132952 137.97181h-177.834667c-82.383238 
            0-150.918095-59.928381-163.132952-137.923048l-306.688-0.048762zM356.59581 
            24.380952L438.857143 167.15581 399.213714 195.047619 316.952381 52.272762zM862.427429 
            24.380952L902.095238 52.272762 819.858286 195.047619 780.190476 
            167.15581zM585.142857 170.666667h48.761905V0h-48.761905z"
            p-id="2875"></path>
        </svg>
        <div>{{title ? title : '无数据'}}</div>
    </div>
</template>

<script>
export default {
    name: 'noData',
    props: ['title']
}
</script>

<style lang="less" scoped>
.noData {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100px;
    height: 100%;
    color: #aaa;
    .icon {
        height: 50px;
        path {
            fill: #aaa;
        }
    }
    div {
        font-size: 14px;
        margin-top: 10px;
    }
}
</style>